import { Button } from "@material-ui/core"
import RefreshIcon from "@material-ui/icons/Refresh"

// Atualização MANUAL da lista (endpoint allday). O refresh automático periódico
// foi removido: a lista se mantém em tempo real via SSE (eventos PLACED/STATUS) +
// drain de eventos. O allday agora só é chamado sob demanda, ao clicar aqui.
// (O status da loja iFood continua sendo consultado à parte, no efeito próprio.)
export default function Segundos({ atualizar }) {
    return (
        <Button onClick={() => atualizar(true)} startIcon={<RefreshIcon fontSize="large" />}>
            Atualizar
        </Button>
    )
}
